export default __webpack_public_path__ + "media/images/home/corporate/lg-262c9885b6c2d41c186a5ad188ebbf41.webp";